module.exports = __webpack_public_path__ + "static/media/foto_loja_pao-de-acucar.e76d28d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustentabilidade/foto_loja_pao-de-acucar.jpg
// module id = 185
// module chunks = 4